import { NO_ROLE_FLAG } from '#components/patterns/entity-select/role/index.ts';
import type { Tag } from '#dn-types/tag.ts';

/**
 * {@link isHostUnreachableWithoutRole} is true when the form's current selections leave the host
 * without any inbound firewall rules: "No role" is selected, and none of the selected tags carry
 * firewall rules. Reachability depends on both the Role and Tags fields, so the host/relay/lighthouse
 * forms surface this warning next to the Save button rather than under either field.
 */
export function isHostUnreachableWithoutRole(roleID: string, selectedTags: string[], allTags: readonly Tag[]) {
  const reachableViaTagRules = selectedTags.some(
    (name) => (allTags.find((tag) => tag.name === name)?.firewallRulesCount ?? 0) > 0
  );
  return roleID === NO_ROLE_FLAG && !reachableViaTagRules;
}
